import { BackednResponse } from "@shared/lib/types";
import { IGetBriefInvoiceFacets } from "@shared/lib/types/briefInvoice";
import { useQuery } from "@tanstack/react-query";
import { BriefService } from "../services/brief.service";
import { useEffect } from "react";
import { ToastService } from "@shared/lib/services";
import { BRIEF_INVOICE_FACETS_QUERY_KEY } from "../constants";

export function useGetBriefInvoiceFacets(briefId: string) {
  const { data, isLoading, isError, error } = useQuery<
    BackednResponse<IGetBriefInvoiceFacets>
  >({
    queryKey: [...BRIEF_INVOICE_FACETS_QUERY_KEY, briefId],
    queryFn: () => BriefService.getBriefInvoiceFacets(briefId),
  });

  const errorMessage = isError && error?.message;

  useEffect(() => {
    if (errorMessage) {
      ToastService.error(errorMessage);
    }
  }, [errorMessage]);

  return {
    facets: data?.data || {
      billing: [],
      type: [],
      subType: [],
    },
    isFetching: isLoading,
    isError,
  };
}
